import React from "react";
import {
	PieChart,
	Pie,
	Cell,
	Legend,
	Tooltip,
	ResponsiveContainer,
} from "recharts";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#AF19FF"];

const PieChartCard = ({ title, data, dataKey = "value" }) => {
	return (
		<div className="dashboard-pie-card">
			<h5 className="dashboard-pie-title">{title}</h5>
			<div className="dashboard-pie-container">
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={data}
							dataKey={dataKey}
							nameKey="label"
							cx="50%"
							cy="50%"
							outerRadius={90}
							label
						>
							{data.map((_, index) => (
								<Cell
									key={`cell-${index}`}
									fill={COLORS[index % COLORS.length]}
								/>
							))}
						</Pie>
						<Tooltip />
						<Legend verticalAlign="bottom" height={36} />
					</PieChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
};

export default PieChartCard;
